import { Subject } from 'rxjs';
import { ConfigOptions } from 'antd/es/message/interface';

type UIMessageType = 'success' | 'error' | 'info' | 'warning' | 'loading';
type MessageOptions = ConfigOptions & { values?: Record<string, unknown> };

export interface UIMessageI {
  type: UIMessageType;
  data: {
    message: string;
    messageOptions: MessageOptions;
  };
}

export const UIMessage = new Subject<UIMessageI>();

export const publishUIMessage = (
  type: UIMessageType,
  message: string,
  messageOptions: MessageOptions = {}
) => UIMessage.next({ type, data: { message, messageOptions } });
